// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {

  apiKey: "AIzaSyACRYdyOPpAMwOrmfPsT7tH_JbdD78I3W4",

  authDomain: "stdchbgh0611rtt.firebaseapp.com",

  databaseURL: "https://stdchbgh0611rtt-default-rtdb.firebaseio.com",

  projectId: "stdchbgh0611rtt",

  storageBucket: "stdchbgh0611rtt.firebasestorage.app",

  messagingSenderId: "36985695200",

  appId: "1:36985695200:web:8f8c541afd3b5802875985",

  measurementId: "G-H8Y5K67P3W"

};




// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { app };